import React, { useEffect } from 'react'
import StudentSidebar from '../../StudentSidebar/StudentSidebar'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { getGroupCourseList } from '../../../../Redux/action/StudentAction';
import Beatloader from '../../../../Common/BeatLoader';

const StudentTutorGroupCourseList = () => {
    const dispatch = useDispatch();
    const { b64id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        try {

            const tutorId = atob(b64id);


            if (!tutorId || isNaN(tutorId)) {
                throw new Error("Invalid course ID");
            }


            dispatch(getGroupCourseList(tutorId));
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);




    const {

        loadingGroupCourseListApi,
        GroupCourseListApiData,
        GroupCourseListApiError,

    } = useSelector(state => state?.StudentReducer);

    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Group Courses
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="view-group-courses">
                                    <h4 className="mb-3">View Group Courses</h4>
                                    {loadingGroupCourseListApi ?
                                        <Beatloader />
                                        :
                                        <div className="row">
                                            {GroupCourseListApiData?.length > 0 ?
                                                GroupCourseListApiData?.map((data) => (
                                                    <div className="col-lg-6 mt-3 col-md-6">
                                                        <div className="card input-card-form bg-white">
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-lg-12 d-flex justify-content-end">
                                                                        <p className="mb-0 text-danger" style={{ fontSize: 13 }}>
                                                                            <i>{data?.expired ? 'Expired' : ''}</i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-lg-12">
                                                                        <p className="mb-0 fw-bold">Class/Grade/General : {data?.category?.name}</p>
                                                                        <p className="mb-0 fw-bold">Subject : {data?.subcategory?.name}</p>
                                                                        <p className="mb-0 fw-bold">Course : {data?.name}</p>
                                                                        <p className="mb-0 fw-bold line-clamp">Description : {data?.description}</p>
                                                                        {data?.expired ? '' : <Link to={`/student/view-group-course-batches/${btoa(data?.id)}`}>
                                                                            <button
                                                                                className="btn btn-outline-primary py-1 w-100 mt-3"

                                                                            >
                                                                                View Course Batches
                                                                            </button>
                                                                        </Link>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                                :
                                                <div className='no-data-img'>
                                                    <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                </div>
                                            }
                                        </div>}
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Group Course Batches Modal */}
                <div
                    className="modal fade"
                    id="groupcoursebatchesModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content bg-light">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Group Course Batches
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body mb-4">
                                <div className="row">
                                    <div className="col-lg-12 mt-3">
                                        <div className="card input-card-form">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <p className="fw-bold mb-0">Max. Students : 20</p>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <p className="fw-bold mb-0 text-end">
                                                            Enroll Students : 1
                                                        </p>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <p className="fw-bold mb-0">Batch Name : Batch 12</p>
                                                        <p className="fw-bold mb-0">Batch Start : 2024-10-30</p>
                                                        <p className="fw-bold mb-0">Batch End : 2024-11-30</p>
                                                    </div>
                                                </div>
                                                <Link to="/student/group-batch-session">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary w-100 my-3"
                                                        data-bs-dismiss="modal"
                                                    >
                                                        View Session
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>


        </div>
    )
}

export default StudentTutorGroupCourseList